(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  if (window.innerWidth > 749) {
    document.querySelector('.collection-hero__titlearrow').setAttribute('data-is-open',true);
    if (document.querySelector('.collection-hero__description').querySelector('p')) {
      document.querySelector('.collection-hero__description').style.height = document.querySelector('.collection-hero__description').querySelector('p').offsetHeight + 'px';
    } else {
      document.querySelector('.collection-hero__description').style.height = document.querySelector('.collection-hero__description').querySelector('span').offsetHeight + 'px';
    }
  };
  document.querySelector('.collection-hero__titlearrow').addEventListener('click', function(e) {
    console.log(e.target)
    if (e.target.getAttribute('data-is-open')) {
      e.target.removeAttribute('data-is-open');
      document.querySelector('.collection-hero__description').style.height = '0px';
    } else {
      e.target.setAttribute('data-is-open', true);
      if (document.querySelector('.collection-hero__description').querySelector('p')) {
        document.querySelector('.collection-hero__description').style.height = document.querySelector('.collection-hero__description').querySelector('p').offsetHeight + 'px';
      } else {
        document.querySelector('.collection-hero__description').style.height = document.querySelector('.collection-hero__description').querySelector('span').offsetHeight + 'px';
      }
    };
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["you-may-also-like"] && !window.DesignMode) return;
  try {
    
  fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(cartdata => {
    if (cartdata.items.length > 0) {
      cartdata.items[0].id;
      fetch(window.Shopify.routes.root + "recommendations/products.json?product_id=" + cartdata.items[0].product_id + "&limit=4&intent=related")
      .then(response => response.json())
      .then(({ products }) => {
        if (products.length > 0) {
          console.log(products);
          console.log(document.querySelector('.product-recommendations').querySelector('ul'))

          products.forEach(product=>{
            let productcontainer = document.createElement('li');
            productcontainer.setAttribute('class', 'product');
            document.querySelector('.product-recommendations').querySelector('ul').appendChild(productcontainer);

            let productlink = document.createElement('a');
            productlink.setAttribute('href', product.url);
            productcontainer.appendChild(productlink);

            let productimg = document.createElement('img');
            productimg.setAttribute('class', 'product__img');
            productimg.setAttribute('src', product.featured_image);
            productimg.setAttribute('width', 300);
            productimg.setAttribute('height', 300);
            productimg.setAttribute('alt', product.title);
            productlink.appendChild(productimg);

            let producttitle = document.createElement('p');
            producttitle.setAttribute('class', 'product__title');
            producttitle.innerHTML = product.title;
            productlink.appendChild(producttitle);

            let productprice = document.createElement('p');
            productprice.setAttribute('class', 'product__title');
            productprice.innerHTML = "{{ cart.currency.symbol }}"+(product.price/100);
            productlink.appendChild(productprice);
          })
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
      })();
